module.exports = __webpack_public_path__ + "media/assets/community/school-logo-c2b09a550f93682203c3d54171199fd86408abcd5e6cb8f3d0c4758f0894af23.png";